import { render } from "./OkrElementSelectItem.vue?vue&type=template&id=0857b4e8&scoped=true"
import script from "./OkrElementSelectItem.vue?vue&type=script&lang=js"
export * from "./OkrElementSelectItem.vue?vue&type=script&lang=js"

import "./OkrElementSelectItem.vue?vue&type=style&index=0&id=0857b4e8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0857b4e8"]])

export default __exports__